import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleRequestPricing = () => {
    const contactLink = document.querySelector('a[href="tel:918-806-8873"]');
    if (contactLink) {
      contactLink.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ease-out ${
      scrolled 
        ? 'bg-white/95 backdrop-blur-sm shadow-sm py-3' 
        : 'bg-transparent py-5'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center transition-opacity duration-200 hover:opacity-80">
            <img 
              src="https://public.readdy.ai/ai/img_res/5e7893d9-3df1-4ab0-9579-21994c142bf0.png" 
              alt="918Turf Tulsa Oklahoma" 
              className={`w-auto transition-all duration-300 ${scrolled ? 'h-12' : 'h-16'}`}
            />
          </Link>

          {/* Right side container for nav links + CTA */}
          <div className="flex items-center gap-8">
            {/* Navigation Links - Hidden when scrolled */}
            <div className={`hidden md:flex items-center gap-6 transition-all duration-300 ${
              scrolled ? 'opacity-0 pointer-events-none w-0 overflow-hidden' : 'opacity-100'
            }`}>
              <Link 
                to="/landscape-turf" 
                className={`text-sm font-medium transition-colors duration-150 cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-gray-700' : 'text-white drop-shadow-md'
                } hover:text-green-600`}
              >
                Turf Products
              </Link>
              <Link 
                to="/about" 
                className={`text-sm font-medium transition-colors duration-150 cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-gray-700' : 'text-white drop-shadow-md'
                } hover:text-green-600`}
              >
                Wholesale
              </Link>
              <Link 
                to="/athletic-turf" 
                className={`text-sm font-medium transition-colors duration-150 cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-gray-700' : 'text-white drop-shadow-md'
                } hover:text-green-600`}
              >
                Accessories
              </Link>
              <Link 
                to="/about" 
                className={`text-sm font-medium transition-colors duration-150 cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-gray-700' : 'text-white drop-shadow-md'
                } hover:text-green-600`}
              >
                About
              </Link>
              <Link 
                to="/about" 
                className={`text-sm font-medium transition-colors duration-150 cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-gray-700' : 'text-white drop-shadow-md'
                } hover:text-green-600`}
              >
                FAQ
              </Link>
              <Link 
                to="/about" 
                className={`text-sm font-medium transition-colors duration-150 cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-gray-700' : 'text-white drop-shadow-md'
                } hover:text-green-600`}
              >
                Contact
              </Link>
            </div>

            {/* CTA Button - Always visible */}
            <button
              onClick={handleRequestPricing}
              className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                scrolled 
                  ? 'bg-green-700 text-white hover:bg-green-800' 
                  : 'bg-white text-green-700 hover:bg-gray-100 shadow-lg'
              }`}
              style={{ transform: 'translateY(0)' }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-1px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              Request Pricing
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
